/*
 * @Author: 温少昌 wenshaochang@huizhihuyu.com
 * @Date: 2024-07-23 09:52:00
 * @LastEditors: 温少昌 wenshaochang@huizhihuyu.com
 * @LastEditTime: 2024-07-23 16:08:57
 * @FilePath: /ny-utils-master/src/auth/loginDeploy.js
 * @Description: 部署登录PC、小程序、安卓和IOS 的登录
 */
import getEnv from '../utils/getEnv';
import getBaseUrl from '../utils/getBaseUrl';
import axios from 'axios';
const baseUrl = getBaseUrl();
const reqUrl = baseUrl + '/auth/oauth2/token';
/**
 * Description 部署至 PC、小程序、安卓和IOS 的登录
 * @param {Number} tenantId 租户ID
 * @param {String} appKey 应用key
 * @param {String} signature 签名
 * @param {String} timestamp 时间戳
 * @param {String} userIdentifier 用户标识
 * @returns {Object} 返回值
 */
export const loginDeployOfCommon = function loginDeployOfCommon(tenantId, appKey, signature, timestamp, userIdentifier) {
    const env = getEnv();
    if(env === 'wxh5') {
        console.log('微信小程序环境，无法使用该接口');
        return false;
    }
    const params = {
        userIdentifier: `H5_USER_IDENTIFIER@${userIdentifier}`,
        grant_type: "h5userIdentifier",
        code: 718600,
        scope: 'server'
    };
    const body = { tenantId, appKey, signature, timestamp };
    axios.post(reqUrl, body, {
        params: params,
        headers: {
            'isToken': false,
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic aDU6aDU=',
            'CLIENT-TOC': 'Y',
            'Tenant-Id': body.tenantId,
            'appKey': body.appKey,
            'signature': body.signature,
            'timestamp': body.timestamp
        }
    }).then((res) => {
        // 请求成功
        console.log('部署登录PC、小程序、安卓和IOS 的登录成功----', res);
        return res;
    }).catch(function (error) {
        // 请求错误
        console.log(error);
        return error;
    }).finally(function () {
        // 总是会执行
        console.log('finally');
    });
}